import React, { useEffect, useMemo, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';
import CryptoJS from 'crypto-js';

import PersonalProfile from './PersonalProfile';
import ProfessionalProfile from './ProfessionalProfile';
import Finance from './Finance'
import PPF from './PPF'
import SideFeed from './SideFeedParent';
import useAvailableHeight from '../../Custom/UseAvailableHeight';
import { useProfileContext } from '../../ProfileDetailContext'
import useApi from '../../Utilities/useAPI';
import { sortListByDate } from '../../Utilities/ValidationFunctions';
import { useUserDetailContext } from '../../UserDetailContext';
import { getAwardsReducer, getCertificateReducer, getEducationReducer, getExperienceReducer, getPersonalHealthDocumentsReducer, getPersonalInfoReducer, getPersonalProfileFamilyReducer, getPersonalProfileHealthReducer, getPersonalProfileHobbiesReducer, getPersonalProfileLanguagesReducer, getProfessionalInfoReducer, getProfessionalSkillsReducer, getProfileCompletionReducer, getProjecteReducer, getResumeReducer, getServiceReducer, getVideoResumeReducer, setEncryptedId } from '../../../Redux/Reducers/ProfileReducer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getVisitingCardReducer } from '../../../Redux/Reducers/CardReducer';

const ParentProfile = () => {
  // const [activeMenu, setActiveMenu] = useState();
  const location = useLocation();

  const { userDetails } = useUserDetailContext();
  const encryptedId = useSelector((state) => state.ProfileArray.encryptedId);
  // console.log("UserDetails data passing to the sideEffect", userDetails.re);

  const { PersonalDetails, setPersonalDetails, updateMedicalAttachments, ProfessionalDetails, setProfessionalDetails, educationList, setEducationList, certificateList, setcertificateList,
    ExperienceList, setExperienceList, setprojectList, setAwardsList, setServices, setResume, setSectionVisibility, setPersonalProfileCompletion, setProfessionalProfileCompletion,
    personalProfileCompletion, professionalProfileCompletion, setConnectionCount, setConnectionList, getCompletionStatus, addSection, setAddSection } = useProfileContext();

  // useEffect(() => {
  //   if (userDetails.reference_id) {
  //     const computedEncryptedId = encodeURIComponent(
  //       CryptoJS.AES.encrypt(
  //         (userDetails.reference_id)?.toString(),
  //         'UserDetailsSecretKey'
  //       ).toString()
  //     );
  //     dispatch(setEncryptedId(computedEncryptedId))
  //   }
  // }, [userDetails.reference_id]);

  useEffect(() => {
    if (userDetails.reference_id) {
      const computedEncryptedId = encodeURIComponent(
        CryptoJS.AES.encrypt(
          (userDetails.reference_id)?.toString(),
          'UserDetailsSecretKey'
        ).toString()
      );
      dispatch(setEncryptedId(computedEncryptedId))
    }
  }, [userDetails.reference_id]);

  // ✅ useSearchParams is reactive — triggers re-render on every URL change
  // ❌ Previously: new URLSearchParams(location.search) — stale snapshot, not reactive
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("mainTab") || "personal_profile"; // Default to personal_profile
  const activeSubTab = searchParams.get("subTab") || null;

  // ✅ Removed activeMenu & activeSubMenu useState — URL (activeTab/activeSubTab) is the single source of truth
  const navigate = useNavigate();
  const { callApiFunction } = useApi();

  useEffect(() => {
    const getAPI = async () => {
      await dispatch(getExperienceReducer());
      await dispatch(getEducationReducer());
      await dispatch(getCertificateReducer());
      await dispatch(getPersonalInfoReducer());
      await dispatch(getProfileCompletionReducer());
      await dispatch(getPersonalProfileLanguagesReducer());
      await dispatch(getPersonalProfileHobbiesReducer());
      await dispatch(getPersonalProfileHealthReducer());
      await dispatch(getPersonalHealthDocumentsReducer());
      await dispatch(getPersonalProfileFamilyReducer());
      await dispatch(getProfessionalInfoReducer());
      await dispatch(getServiceReducer());
      await dispatch(getProfessionalSkillsReducer());
      await dispatch(getProjecteReducer());
      await dispatch(getAwardsReducer());
      await dispatch(getResumeReducer());

    }
    getAPI();
  }, []);


  // useEffect(() => {
  //   if (activeMenu !== activeTab) {
  //     setActiveMenu(activeTab);
  //   }
  //   if (activeSubTab) {
  //     // Handle sub tab selection here
  //     // You might need to create a new state for subTab
  //     setActiveSubMenu(activeSubTab);
  //   }
  // }, [activeTab]);

  // const handleMenuClick = (_, newValue) => {
  //   setActiveMenu(newValue);
  //   const currentSubTab = searchParams.get("subTab");
  //   const newUrl = currentSubTab
  //     ? `/myprofile?mainTab=${newValue}&subTab=${currentSubTab}`
  //     : `/myprofile?mainTab=${newValue}`;
  //   navigate(newUrl);
  // };

  //   const handleMenuClick = (_, newValue) => {
  //   console.log("Tab clicked:", newValue);
  //   setActiveMenu(newValue);

  //   // Get current subtab if exists
  //   const currentSubTab = searchParams.get("subTab");

  //   // Create new URL with the selected tab
  //   const newUrl = currentSubTab
  //     ? `/myprofile?mainTab=${newValue}&subTab=${currentSubTab}`
  //     : `/myprofile?mainTab=${newValue}`;

  //   console.log("Navigating to:", newUrl);
  //   navigate(newUrl);
  // };

  // const handleMenuClick = (_, newValue) => {
  //   const currentSubTab = searchParams.get("subTab");
  //   const newUrl = currentSubTab
  //     ? `/myprofile?mainTab=${newValue}&subTab=${currentSubTab}`
  //     : `/myprofile?mainTab=${newValue}`;
  //   navigate(newUrl);
  // };

  const handleMenuClick = (_, newValue) => {
  // Define default subTab for each main tab
  const defaultSubTabs = {
    personal_profile: "my_profile",       // whatever your default is
    professional_profile: "professional_info", // whatever your default is
    finance: null,
    ppf_score: null,
  };

  const defaultSubTab = defaultSubTabs[newValue];
  const newUrl = defaultSubTab
    ? `/myprofile?mainTab=${newValue}&subTab=${defaultSubTab}`
    : `/myprofile?mainTab=${newValue}`;

  navigate(newUrl);
};

  const [personalProResponse, setPersonalProResponse] = useState({
    personalfamily: false,
    personalHealth: false,
    personalMyprofile: false,
    personlaHobbies: false,
    personalLanguage: false,

  });

  const [professionalProResponse, setProfessionalProResponse] = useState({
    professionalInfo: false,
    professionalSkill: false,
    professionalProEducation: false,
    professionalProCertificate: false,
    professionalProExperience: false,
    professionalProResume: false,

  });

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [availableHeight1, mainAreaRef] = useAvailableHeight(138);
  const [availableHeight2, sideFeedRef] = useAvailableHeight(138);
  const videoResume = useSelector((state) => state?.ProfileArray?.videoResume);
  const videoUrlArray = videoResume;

  useEffect(() => {
    dispatch(getVideoResumeReducer());
    // dispatch(getVisitingCardReducer({ encryptedId }));
  }, [dispatch]);




  // const getEducation = async () => {
  //   const Education_Info = 'education_Info';
  //   if (professionalProResponse.professionalProEducation) {
  //     const storedEducation = localStorage.getItem(Education_Info);
  //     if (storedEducation) {
  //       localStorage.removeItem(Education_Info);
  //       const response = await callApiFunction('educationRead');
  //       const data = response?.data;

  //       if (response?.status === 'SUCCESS') {
  //         const transformedData = transformEducationData(data);
  //         const sortedEducationList = sortListByDate(transformedData, 'education');

  //         const isEducationPublic = data.length > 0 ? Boolean(data[0].is_visible ?? true) : true;

  //         const educationInfo = {
  //           education: sortedEducationList,
  //           isSectionPublic: { education: isEducationPublic },
  //         };

  //         setEducationList(sortedEducationList);
  //         localStorage.setItem(Education_Info, JSON.stringify(educationInfo));

  //         setProfessionalProResponse((prevState) => ({
  //           ...prevState,
  //           professionalEducation: false,
  //         }));
  //       } else {
  //         console.error("Failed to fetch Education:", response?.message);
  //       }
  //     }
  //   } else {
  //     const storedEducation = localStorage.getItem(Education_Info);
  //     if (storedEducation) {
  //       const parsedEducation = JSON.parse(storedEducation);
  //       setEducationList(parsedEducation.education || []);
  //     } else {
  //       const response = await callApiFunction('educationRead');
  //       const data = response?.data;

  //       if (response?.status === 'SUCCESS') {
  //         const transformedData = transformEducationData(data);
  //         const sortedEducationList = sortListByDate(transformedData, 'education');

  //         const isEducationPublic = data.length > 0 ? Boolean(data[0].is_visible ?? true) : true;

  //         const educationInfo = {
  //           education: sortedEducationList,
  //           isSectionPublic: { education: isEducationPublic },
  //         };

  //         setEducationList(sortedEducationList);
  //         localStorage.setItem(Education_Info, JSON.stringify(educationInfo));

  //         setProfessionalProResponse((prevState) => ({
  //           ...prevState,
  //           professionalEducation: false,
  //         }));
  //       } else {
  //         console.error("Failed to fetch Education:", response?.message);
  //       }
  //     }
  //   }
  // };

  // const getCertificates = async () => {

  //   const Certificate_Info = 'certificates_Info';
  //   if (professionalProResponse.professionalProCertificate) {
  //     const storedCertificates = localStorage.getItem(Certificate_Info);
  //     if (storedCertificates) {
  //       localStorage.removeItem(Certificate_Info);
  //       const response = await callApiFunction('certificateRead');
  //       const data = response?.data;

  //       if (response?.status === 'SUCCESS') {
  //         const transformedData = transformCertificateData(data);
  //         const sortedCertificateList = sortListByDate(transformedData, 'certificates');

  //         // Assuming all certificates have the same is_visible value
  //         const isCertificatePublic = data.length > 0 ? Boolean(data[0].is_visible ?? true) : true;

  //         const certificateInfo = {
  //           certificates: sortedCertificateList,
  //           isSectionPublic: { certificates: isCertificatePublic },
  //         };

  //         setcertificateList(sortedCertificateList);
  //         setSectionVisibility('certificates', isCertificatePublic);
  //         localStorage.setItem(Certificate_Info, JSON.stringify(certificateInfo));
  //         setProfessionalProResponse((prevState) => ({
  //           ...prevState,
  //           professionalProCertificate: false,
  //         }));
  //       } else {
  //         console.error("Failed to fetch Certificates:", response?.message);
  //       }
  //     }
  //   } else {
  //     const storedCertificates = localStorage.getItem(Certificate_Info);
  //     if (storedCertificates) {
  //       const parsedCertificates = JSON.parse(storedCertificates);

  //       setcertificateList(parsedCertificates.certificates || []);
  //       setSectionVisibility(
  //         'certificates',
  //         parsedCertificates.isSectionPublic?.certificates ?? true // Default to true if undefined
  //       );
  //     } else {
  //       const response = await callApiFunction('certificateRead');
  //       const data = response?.data;

  //       if (response?.status === 'SUCCESS') {
  //         const transformedData = transformCertificateData(data);
  //         const sortedCertificateList = sortListByDate(transformedData, 'certificates');

  //         const isCertificatePublic = data.length > 0 ? Boolean(data[0].is_visible ?? true) : true;

  //         const certificateInfo = {
  //           certificates: sortedCertificateList,
  //           isSectionPublic: { certificates: isCertificatePublic },
  //         };

  //         setcertificateList(sortedCertificateList);
  //         setSectionVisibility('certificates', isCertificatePublic);
  //         localStorage.setItem(Certificate_Info, JSON.stringify(certificateInfo));
  //         setProfessionalProResponse((prevState) => ({
  //           ...prevState,
  //           professionalProCertificate: false,
  //         }));
  //       } else {
  //         console.error("Failed to fetch Certificates:", response?.message);
  //       }
  //     }
  //   }
  // };

  // const getExperiences = async () => {

  //   const Experience_Info = 'experiences_Info';
  //   if (professionalProResponse.professionalProExperience) {
  //     const storedExperiences = localStorage.getItem(Experience_Info);
  //     if (storedExperiences) {
  //       localStorage.removeItem(Experience_Info);
  //       const response = await callApiFunction('experienceRead');
  //       const data = response?.data;

  //       if (response?.status === 'SUCCESS') {
  //         const transformedData = transformExperienceData(data);
  //         const sortedExperienceList = sortListByDate(transformedData, 'experience');

  //         // Assuming all experiences have the same is_visible value
  //         const isExperiencePublic = data.length > 0 ? Boolean(data[0].is_visible ?? true) : true;

  //         const experienceInfo = {
  //           experiences: sortedExperienceList,
  //           isSectionPublic: { experiences: isExperiencePublic },
  //         };

  //         setExperienceList(sortedExperienceList);
  //         setSectionVisibility('experiences', isExperiencePublic);
  //         localStorage.setItem(Experience_Info, JSON.stringify(experienceInfo));
  //         setProfessionalProResponse((prevState) => ({
  //           ...prevState,
  //           professionalProExperience: false,
  //         }));
  //       } else {
  //         console.error("Failed to fetch Experiences:", response?.message);
  //       }
  //     }
  //   } else {
  //     const storedExperiences = localStorage.getItem(Experience_Info);
  //     if (storedExperiences) {
  //       const parsedExperiences = JSON.parse(storedExperiences);

  //       setExperienceList(parsedExperiences.experiences || []);
  //       setSectionVisibility(
  //         'experiences',
  //         parsedExperiences.isSectionPublic?.experiences ?? true // Default to true if undefined
  //       );
  //     } else {
  //       const response = await callApiFunction('experienceRead');
  //       const data = response?.data;

  //       if (response?.status === 'SUCCESS') {
  //         const transformedData = transformExperienceData(data);
  //         const sortedExperienceList = sortListByDate(transformedData, 'experience');

  //         const isExperiencePublic = data.length > 0 ? Boolean(data[0].is_visible ?? true) : true;

  //         const experienceInfo = {
  //           experiences: sortedExperienceList,
  //           isSectionPublic: { experiences: isExperiencePublic },
  //         };

  //         setExperienceList(sortedExperienceList);
  //         setSectionVisibility('experiences', isExperiencePublic);
  //         localStorage.setItem(Experience_Info, JSON.stringify(experienceInfo));
  //         setProfessionalProResponse((prevState) => ({
  //           ...prevState,
  //           professionalProExperience: false,
  //         }));
  //       } else {
  //         console.error("Failed to fetch Experiences:", response?.message);
  //       }
  //     }
  //   }
  // };


  const getConnectionCount = async () => {
    try {
      const response = await callApiFunction('getConnectionCount');
      if (response.status === 'SUCCESS') {
        setConnectionCount(response.connectionCount);
      }
    } catch (error) {
      console.log("Error fetching Connection Count data:", error);
    }
  }

  const getConnectedContacts = async () => {
    try {
      const response = await callApiFunction('ConnectedContacts');

      if (response?.statusCode === 200) {
        const members = response.data.map(member => ({
          id: member.id,
          profilePic: member.profile_url,
          contactRedId: member.contact_ref_id,
          encryptedContactRefId: CryptoJS.AES.encrypt(member.contact_ref_id.toString(), 'UserDetailsSecretKey').toString(),
          contactName: `${member.first_name} ${member.last_name}`,
          contactRole: member.relationship_type,
          isVerified: member.is_verified ? true : false,
          isFavourite: member?.is_favourite ? true : false,
          isActive: true,
          connectedSince: getConnectedDays(member.created_at),
          role: member.designation || member.field_of_study || member.title || '---',
          subTitle: member.company || member.institute || member.nickname || '---',
        }));
        // Sort by contactName (ascending order)
        const sortedMembers = members.sort((a, b) => {
          return a.contactName.localeCompare(b.contactName);  // Sort alphabetically
        });

        // Set the sorted members to state
        setConnectionList(sortedMembers);
      }
    } catch (err) {
      console.log('Error fetching Connection List Data:', err);
    }
  }

  useEffect(() => {

    const connectionInfo = async () => {
      await Promise.all([getConnectionCount(), getConnectedContacts()]);
    }

    try {
      setIsLoading(true);
      // personalTabInfo();
      // professionalTabInfo();
      // connectionInfo();
      getCompletionStatus();

    } catch (error) {
      console.error("Error in useEffect function:", error);
    } finally {
      setIsLoading(false);
    }
  }, [])

  if (location.pathname === '/myprofile/create-video-resume') {
    return <Outlet />;
  }

  if (isLoading) {
    return <> Loading... </>
  }

  // const getAPIs = {
  //   getExperiences: getExperiences,
  //   getEducation: getEducation,
  //   getCertificates: getCertificates,
  //   // getFamilyInfodata: getFamilyInfo

  // }

  return (
    <>
      <div className='my-Profile-part'>
        <div className="d-flex">

          <div className="myprofile-column-1 text-center" ref={mainAreaRef} style={{ /*maxHeight: `${availableHeight1}px`,*/ overflowY: "auto", scrollbarWidth: "none" }}>
            <div className="mt-20px menu">
              <Tabs
                value={activeTab}
                onChange={handleMenuClick}
                aria-label="Profile Tabs"
                variant="scrollable"
                scrollButtons="auto"
                className='custom-profile-tabs'
              // selectionFollowsFocus
              >
                <Tab
                  label="Personal Profile"
                  value="personal_profile"
                // onClick={handlePersonalTabClick}
                />
                <Tab
                  label="Professional Profile"
                  value="professional_profile"
                // onClick={handleProfessionalTabClick}
                />
                <Tab
                  label="Financial"
                  value="finance"
                />
                <Tab
                  label="PPF Score"
                  value="ppf_score"
                />
              </Tabs>
            </div>
            <div className='content-for-that-link'>
              {/* ✅ Using activeTab from useSearchParams — always in sync with URL */}
              {activeTab === 'personal_profile' && (
                <>
                  <PersonalProfile settriggeredApi={setPersonalProResponse} />
                </>
              )}
              {activeTab === 'professional_profile' && (
                <>
                  {/* <ProfessionalProfile getAPIs={getAPIs} settriggeredApi={setProfessionalProResponse} videoUrlArray={videoUrlArray} /> */}
                  <ProfessionalProfile settriggeredApi={setProfessionalProResponse} videoUrlArray={videoUrlArray} />
                </>
              )}
              {activeTab === 'finance' && (
                <>
                  <Finance />
                </>
              )}
              {activeTab === 'ppf_score' && (
                <>
                  <PPF />
                </>
              )}
            </div>
          </div>

          <div className="myprofile-column-2" ref={sideFeedRef} style={{ /*maxHeight: `${availableHeight2}px`,*/ overflowY: "auto", scrollbarWidth: "none" }} >
            <SideFeed activeProfile={activeTab} viewedUserId={userDetails.reference_id} encryptedId={encryptedId} />
          </div>
        </div>
      </div>
      <Outlet />
    </>
  )
}

export default ParentProfile


const transformFamilyData = (data) => {
  const details = {
    fatherDet: { id: '', fName: '', lName: '', dob: '', blood: '', email: '', phoneNo: '', isVerified: false },
    motherDet: { id: '', fName: '', lName: '', dob: '', blood: '', email: '', phoneNo: '', isVerified: false },
    spouseDet: { id: '', fName: '', lName: '', dob: '', blood: '', email: '', phoneNo: '', isVerified: false },
    kids: [],
    isFamilyPublic: true,
  };

  data?.forEach((member) => {
    const {
      id,
      relation_name,
      relative_first_name,
      relative_last_name,
      relative_dob,
      relative_blood_group,
      guardian_email,
      guardian_phone_no,
      is_guardian_verified,
      is_public,
    } = member;

    switch (relation_name) {
      case 'Father':
        details.fatherDet = {
          id: id,
          fName: relative_first_name,
          lName: relative_last_name,
          dob: relative_dob,
          blood: relative_blood_group,
          email: guardian_email || '',
          phoneNo: guardian_phone_no || '',
          isVerified: is_guardian_verified
        };
        break;
      case 'Mother':
        details.motherDet = {
          id: id,
          fName: relative_first_name,
          lName: relative_last_name,
          dob: relative_dob,
          blood: relative_blood_group,
          email: guardian_email || '',
          phoneNo: guardian_phone_no || '',
          isVerified: is_guardian_verified
        };
        break;
      case 'Spouse':
        details.spouseDet = {
          id: id,
          fName: relative_first_name,
          lName: relative_last_name,
          dob: relative_dob,
          blood: relative_blood_group,
          email: guardian_email || '',
          phoneNo: guardian_phone_no || '',
          isVerified: is_guardian_verified
        };
        break;
      default:
        details.kids.push({
          id: id,
          fName: relative_first_name,
          lName: relative_last_name,
          dob: relative_dob,
          blood: relative_blood_group,
        });
        break;
    }

    details.isFamilyPublic = Boolean(is_public ?? true);
  });

  return details;
};

export const transformEducationData = (data) => {
  return data?.map(item => ({
    id: item.id,
    instlogo: {
      name: 'educationLogo.png',
      type: 'image/png',
      data: item.logo_link || ''
    },
    certificatepic: {
      name: 'educationCertificate.png',
      type: 'image/png',
      data: item.certificate_link || ''
    },
    eduLevel: item.educational_level,
    universityName: item.board,
    fieldofStudy: item.field_of_study,
    institute: item.institute_name,
    instituteDomain: item?.institute_domain,
    degree: item.degree || '',
    grade: item.percentage || '',
    startYear: item.start_year,
    endYear: item.is_pursuing === true ? 'Present' : item.end_year,
    isCurrentlyPursuing: item.is_pursuing,
    description: item.desc || '',
    isPublic: Boolean(item.is_public ?? true),
    isVerified: Boolean(item.is_verified ?? false)
  }));
};

export const transformCertificateData = (data) => {
  return data?.map(item => ({
    id: item.id,
    certificateLogo: {
      name: 'logo.png',
      type: 'image/png',
      data: item.certificate_logo,
    },
    certificatePDF: {
      name: 'certificateImage.png',
      type: 'image/png',
      data: item.certificate_doc,
    },
    organName: item.organisation_name,
    organDomain: item?.organisation_domain,
    courseName: item.course_name,
    certifiDetails: item.description,
    certifiMonth: item.issue_date,
    certifiYear: item.year,
    isPublic: Boolean(item.is_public ?? true),
    isVerified: Boolean(item.is_verified ?? false),
  }));
};

export const transformExperienceData = (data) => {
  return data?.map(item => ({
    id: item.id,
    companylogo: {
      name: 'logo.png',
      type: 'image/png',
      data: item.company_logo,
    },
    companyName: item.company_name,
    companyDomain: item?.company_domain,
    location: item.location,
    locationType: item.location_type,
    roleTitle: item.role_title,
    employmentType: item.employee_type,
    details: item.details,
    startMonth: item.start_month,
    startYear: item.start_year,
    endMonth: item.end_month,
    endYear: item.is_currently_working === true ? 'Present' : item.end_year,
    responsibility: item.responsibility
      ? item.responsibility.split(", ").filter(Boolean)  // Convert to array and remove empty items
      : [],
    headline: item.profile_headline,
    isCurrentlyWorking: item.is_currently_working,
    isPublic: Boolean(item.is_public ?? true),
    isVerified: Boolean(item.is_verified ?? false)
  }));
};

export const transformProjectData = (data) => {
  return data?.map(item => ({
    id: item.id,
    projectName: item.project_name,
    projectDescription: item.project_description,
    startMonth: item.start_month,
    startYear: item.start_year,
    endMonth: item.end_month,
    endYear: item.end_year,
    currentlyWorking: item.is_current_project,
    isPublic: Boolean(item.is_public ?? true),
    attachments: item.attachments?.map(attachment => ({
      id: attachment.id,
      name: attachment.document_name,
      data: attachment.document_url,
      type: attachment.document_type,
      size: JSON.parse(attachment.document_meta)?.document_size || 'Unknown',
      date: new Date(attachment.created_at).toLocaleDateString(), // Convert created_at to a readable date format
    })) || [], // Default to an empty array if there are no attachments
  }));
};

export const transformAwardsData = (data) => {
  return data?.map(item => ({
    id: item.id,
    awardTitle: item.award_title,
    associatedWith: item.associated_with,
    awardIssuer: item.issuer,
    issueMonth: item.issue_month,
    issueYear: item.issue_year,
    awardDescription: item.description,
    isPublic: Boolean(item.is_public ?? true),
    awardAttachments: item.attachments?.map(attachment => ({
      id: attachment.id,
      name: attachment.document_name,
      data: attachment.document_url,
      type: attachment.document_type,
      size: JSON.parse(attachment.document_meta)?.document_size || 'Unknown',
      date: new Date(attachment.created_at).toLocaleDateString(), // Convert created_at to a readable date format
    })) || [], // Default to an empty array if there are no attachments
  }));
};

export const getConnectedDays = (createdAt) => {
  const createdDate = new Date(createdAt); // Convert the created_at timestamp to a Date object
  const currentDate = new Date(); // Get the current date

  // Calculate the difference in milliseconds
  const timeDifference = currentDate - createdDate;

  // Convert the time difference to days, months, and years
  const daysPassed = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const monthsPassed = Math.floor(daysPassed / 30); // Approximate months (30 days per month)
  const yearsPassed = Math.floor(daysPassed / 365); // Approximate years (365 days per year)

  if (yearsPassed > 0) {
    return { value: yearsPassed, unit: `year${yearsPassed > 1 ? 's' : ''}` };
  } else if (monthsPassed > 0) {
    return { value: monthsPassed, unit: `month${monthsPassed > 1 ? 's' : ''}` };
  } else {
    return { value: daysPassed, unit: `day${daysPassed > 1 ? 's' : ''}` };
  }
};